import { memo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
// Import Types
import type { CampaignBudgetLimit } from 'types';
// Import UI Components
import { Tooltip } from '@geneui/components';
// Import Store
import { useAppSelector } from 'store';
import { selectWarningThresholdPercentage } from 'store/slices/partnerSettings';
// Import Helpers
import { getPercentageStatus, getPercentageDescription, formatLimit } from './helpers';
// Import Styles
import styles from './campaignBudgetInfo.module.scss';

const CampaignBudgetInfo: React.FC<CampaignBudgetLimit> = ({ LimitValue, UsedLimit, CurrencyId }) => {
    const { t } = useTranslation();
    const warningThresholdPercentage = useAppSelector(selectWarningThresholdPercentage);

    const currency = CurrencyId || '';

    const percentage = (formatLimit((UsedLimit / LimitValue) * 100, 1) as string) ?? '0';
    const percentageStatus = getPercentageStatus(percentage, warningThresholdPercentage ?? 50);
    const percentageDescription = getPercentageDescription(percentageStatus, t, warningThresholdPercentage ?? 50);

    return (
        <Tooltip
            text={
                (
                    <div className={styles.tooltip}>
                        <p>
                            {formatLimit(UsedLimit)} {currency} / {formatLimit(LimitValue)} {currency}
                        </p>
                        <p>{percentageDescription}</p>
                    </div>
                ) as unknown as string
            }
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            size={`default ${styles.tooltipContainer}`} // Custom way to set container className for Tooltip component
        >
            <div className={classNames(styles.statusLabel, styles[percentageStatus])}>{percentage}%</div>
        </Tooltip>
    );
};

export default memo(CampaignBudgetInfo);
